// extracted by mini-css-extract-plugin
module.exports = {"link":"ExternalLink_link__3AbAk","active":"ExternalLink_active__19hZz"};